/* eslint-disable */
jQuery('.area-menu__navigation .menu-item-has-children').each(function (index, data) {
  const text = jQuery(this).find('> a').text();
  jQuery(this).find('> .sub-menu').prepend(`<li class="first-item">${text}</li>`);
});
